const normalizeText = (value) => {
  if (value === null || value === undefined) return null;
  const text = String(value).trim();
  return text ? text : null;
};

const normalizeRows = (items = []) =>
  (Array.isArray(items) ? items : [])
    .map((item) => ({
      key: normalizeText(item?.key) || "custom",
      label: normalizeText(item?.label),
      value: normalizeText(item?.value),
    }))
    .filter((item) => item.label && item.value);

const normalizeNumericalResults = (value) => {
  if (!value || typeof value !== "object") return null;

  const rows = (Array.isArray(value.rows) ? value.rows : [])
    .map((row) => ({
      item: normalizeText(row?.item) || "",
      metric: normalizeText(row?.metric) || "",
      value: normalizeText(row?.value) || "",
      change: normalizeText(row?.change) || "",
    }))
    .filter((row) => row.item || row.metric || row.value || row.change);

  if (!rows.length) return null;

  return {
    description: normalizeText(value.description),
    columns: {
      item: normalizeText(value.columns?.item) || "البند",
      metric: normalizeText(value.columns?.metric) || "النسبة",
      value: normalizeText(value.columns?.value) || "القيمة",
      change: normalizeText(value.columns?.change) || "التغير",
    },
    rows,
  };
};

const normalizeList = (items = []) =>
  (Array.isArray(items) ? items : [])
    .map((item) => normalizeText(item))
    .filter(Boolean);

const getReportSource = ({ aiAnalysis, reportApiResponse }) =>
  aiAnalysis || reportApiResponse?.aiAnalysis || reportApiResponse?.rawAIResponse?.data?.report || null;

export const normalizeReportViewModel = ({ aiAnalysis, reportApiResponse }) => {
  const report = getReportSource({ aiAnalysis, reportApiResponse });

  return {
    hasError: Boolean(reportApiResponse?.aiServiceFailure || !report),
    errorMessage: reportApiResponse?.userFacingAiError || "",
    reportTitle: normalizeText(report?.reportTitle),
    reportSubtitle: normalizeText(report?.reportSubtitle),
    reportDescription: normalizeText(report?.reportDescription),
    reportMeta: normalizeRows(report?.reportMeta),
    basicReportData: normalizeRows(report?.basicReportData),
    numericalResults: normalizeNumericalResults(report?.numericalResults),
    analysis: normalizeList(report?.analysis),
    recommendationsAndAlerts: normalizeList(report?.recommendationsAndAlerts),
  };
};
